import { css } from 'styled-components';
import { typography } from './theme';

export default css`
  html,
  body,
  #root {
    height: 100%;
    letter-spacing: 1;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: #ffffff;
    font-family: ${typography('fontFamily')};
    font-size: ${typography('body1.fontSize')};
    letter-spacing: ${typography('body1.letterSpacing')};
  }

  button,
  a {
    &:focus {
      outline: none;
    }
  }
`;
